export default __webpack_public_path__ + "static/media/Bulb.a363395e.svg";